module.exports = "./img/desktop_logo.7dfaeb7.png";